/**
 * Client-side mirror of the API's completeUsAddress check (backend
 * services/address.ts), used to warn before a round trip. The server is the
 * authority and also normalizes the text; this only asks "does it end in a
 * state and ZIP, and start with a street number or PO Box?".
 */
export const ADDRESS_HINT = 'Street, city, state and ZIP — e.g. 123 Main Street, Tampa, FL 33602';

export function looksLikeFullAddress(raw: string | null | undefined): boolean {
  const text = (raw ?? '').replace(/\s+/g, ' ').trim();
  if (!/[\s,][A-Za-z]{2}[\s,]+\d{5}(?:[\s-]+\d{4})?$/.test(text)) return false;
  if (!/^\d/.test(text) && !/^P\.?\s*O\.?\s*BOX\b/i.test(text)) return false;
  // Something between the street and the state: a city.
  return text.replace(/[\s,]+[A-Za-z]{2}[\s,]+\d{5}(?:[\s-]+\d{4})?$/, '').split(/[\s,]+/).length >= 3;
}
